var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaysceLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.969 5.0542C15.2438 8.58447 17.2878 11.7564 19.5536 15.2716C21.8028 11.7489 23.8312 8.57162 26.034 5.12223C28.1806 6.4648 30.173 7.7106 32.4837 9.15597C30.5677 12.2312 28.7417 15.1612 26.5928 18.6098C30.4876 18.6098 33.8941 18.6098 37.4346 18.6098C37.4346 21.2904 37.4346 23.5651 37.4346 26.2562C33.9914 26.2562 30.5812 26.2562 26.5253 26.2562C28.687 29.6905 30.4793 32.5382 32.4552 35.6776C30.4232 37.0587 28.475 38.3824 26.177 39.9449C24.0154 36.6293 21.9152 33.4075 19.5611 29.7978C17.2788 33.2586 15.1681 36.46 12.9076 39.8882C10.7452 38.4776 8.77685 37.194 6.60698 35.7789C8.53193 32.6757 10.3146 29.8016 12.3781 26.4747C8.65851 26.4747 5.2655 26.4747 1.68225 26.4747C1.68225 23.7155 1.68225 21.3653 1.68225 18.7179C5.13518 18.7179 8.48025 18.7179 12.4657 18.7179C10.3685 15.3048 8.57462 12.3861 6.60698 9.18469C8.72892 7.80736 10.704 6.52527 12.969 5.0542Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaysceLogo);
export default __webpack_public_path__ + "static/media/playsce-logo.95c71b289e7dc965def37e68f82a384e.svg";
export { ForwardRef as ReactComponent };